import { IApiRoutingRule, IApiRoutingRuleUpdate, IApiRuleId } from '@cbridge-packages/api';
import { RuleTranslator, toApiRuleRegexp, toUiRuleRegexp } from '@cbridge-packages/rule';
import { IRoutingRule, IRoutingImportRule } from './routingRule.interface';

export namespace RoutingRuleTranslator {
  export function fromApi(rule: IApiRoutingRule): IRoutingRule {
    const baseRule = RuleTranslator.fromApiClientRule(rule);
    return {
      ...baseRule,
      accounts: rule.accounts,
      accountRegexp: toUiRuleRegexp(rule.accountRegexp),
      accountGroups: rule.accountGroups,
      accountGroupRegexp: toUiRuleRegexp(rule.accountGroupRegexp),
      comment: rule.comment,
      side: rule.side,
      minVolume: rule.minVolume,
      maxVolume: rule.maxVolume,
      country: rule.country,
      color: rule.color,
    };
  }

  export function toApi(rule: IRoutingRule): IApiRoutingRuleUpdate {
    const baseUpdate = RuleTranslator.toApiClientRule(rule);
    return {
      ...baseUpdate,
      accounts: rule.accounts,
      accountRegexp: toApiRuleRegexp(rule.accountRegexp),
      accountGroups: rule.accountGroups,
      accountGroupRegexp: toApiRuleRegexp(rule.accountGroupRegexp),
      comment: rule.comment || undefined,
      side: rule.side || undefined,
      minVolume: rule.minVolume ?? undefined,
      maxVolume: rule.maxVolume ?? undefined,
      country: rule.country || undefined,
      color: rule.color || undefined,
    };
  }

  export function fromApiImport(rule: IApiRoutingRule & IApiRuleId): IRoutingImportRule {
    const baseResult = RuleTranslator.fromApiClientRule(rule);
    return {
      ...baseResult,
      id: rule.id,
      accounts: rule.accounts,
      accountRegexp: toUiRuleRegexp(rule.accountRegexp),
      accountGroups: rule.accountGroups,
      accountGroupRegexp: toUiRuleRegexp(rule.accountGroupRegexp),
      comment: rule.comment,
      side: rule.side,
      minVolume: rule.minVolume,
      maxVolume: rule.maxVolume,
      country: rule.country,
      color: rule.color,
    };
  }
}
